import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Auth from "./pages/Auth/Auth";
import Home from "./pages/Home/Home";
import OrganizationDashboard from "./pages/OrganizationDashboard/OrganizationDashboard";
import BrickSeries from "./pages/BrickSeries/BrickSeries";
import LegacySeriesRedirect from "./pages/BrickSeries/LegacySeriesRedirect";
import MasterImageEditor from "./pages/MasterImageEditor/MasterImageEditor";
import AcceptInvitation from "./pages/AcceptInvitation/AcceptInvitation";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import { SessionProvider } from "./session/SessionContext";
import RequireSession from "./session/RequireSession";
import RequireOrganizationAccess from "./session/RequireOrganizationAccess";

const App: React.FC = () => (
  <SessionProvider>
    <Router>
      <Routes>
        <Route path="/login" element={<Auth />} />
        <Route path="/invitation" element={<AcceptInvitation />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route element={<RequireSession />}>
          <Route path="/" element={<Home />} />
          <Route path="/:organizationId" element={<RequireOrganizationAccess />}>
            <Route index element={<OrganizationDashboard />} />
            <Route path="series/:seriesId" element={<BrickSeries />} />
            <Route
              path="series/:seriesId/masterImages/:masterImageId"
              element={<MasterImageEditor />}
            />
            <Route path="collections/*" element={<LegacySeriesRedirect />} />
          </Route>
        </Route>
      </Routes>
    </Router>
    <Toaster position="bottom-right" richColors />
  </SessionProvider>
);

export default App;
